import type React from 'react';

import { Image, Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

export const Instructions: React.FC = () => {
	const { translate } = useI18n();

	return (
		<div className="flex flex-col gap-4">
			<Text size="large" fontWeight="bold" variant="body">
				<Translate value="corgi.petition.starter_dashboard_v2.ready_to_share.share_preview_modal.instructions.heading" />
			</Text>
			<ul className="flex flex-col gap-4">
				<li key="instruction-1" className="flex flex-row items-center gap-4">
					<Image
						src="https://static.change.org/images/pre-made-post-modal-instructions-1.svg"
						alt={translate(
							'corgi.petition.starter_dashboard_v2.ready_to_share.share_preview_modal.instructions.step_1_alt',
						)}
						className="h-[80px] w-[81px] bg-transparent"
					/>
					<Text variant="body" fontWeight="bold">
						{translate(
							'corgi.petition.starter_dashboard_v2.ready_to_share.share_preview_modal.instructions.step_1_label',
						)}{' '}
						<br />
						{translate(
							'corgi.petition.starter_dashboard_v2.ready_to_share.share_preview_modal.instructions.step_1_description',
						)}
					</Text>
				</li>
				<li key="instruction-2" className="flex flex-row items-center gap-4">
					<Image
						src="https://static.change.org/images/pre-made-post-modal-instructions-2.svg"
						alt={translate(
							'corgi.petition.starter_dashboard_v2.ready_to_share.share_preview_modal.instructions.step_2_alt',
						)}
						className="h-[80px] w-[81px] bg-transparent"
					/>
					<Text variant="body" fontWeight="bold">
						{translate(
							'corgi.petition.starter_dashboard_v2.ready_to_share.share_preview_modal.instructions.step_2_label',
						)}{' '}
						<br />
						{translate(
							'corgi.petition.starter_dashboard_v2.ready_to_share.share_preview_modal.instructions.step_2_description',
						)}
					</Text>
				</li>
			</ul>
		</div>
	);
};
